export default "__VITE_ASSET__3zDmwWez__"